import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import formatter from './utils/formatter'
import bus from './bus'
import store from './store'
import './plugins/element.js'
import echarts from 'echarts'
import VueQrcode from '@chenfengyuan/vue-qrcode';


Vue.config.productionTip = false
Vue.prototype.$formatter = formatter;
Vue.prototype.$bus = bus;
Vue.prototype.$echarts = echarts;

Vue.component(VueQrcode.name, VueQrcode);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
